var map = {
	"./de/buddy_read.webp": 410,
	"./de/discover.webp": 411,
	"./de/friends.webp": 412,
	"./de/library.webp": 413,
	"./en/buddy_read.webp": 414,
	"./en/discover.webp": 415,
	"./en/friends.webp": 416,
	"./en/library.webp": 417,
	"./es/buddy_read.webp": 418,
	"./es/discover.webp": 419,
	"./es/friends.webp": 420,
	"./es/library.webp": 421,
	"./fr/buddy_read.webp": 422,
	"./fr/discover.webp": 423,
	"./fr/friends.webp": 424,
	"./fr/library.webp": 425,
	"./ru/buddy_read.webp": 426,
	"./ru/discover.webp": 427,
	"./ru/friends.webp": 428,
	"./ru/library.webp": 429,
	"./zh-CN/buddy_read.webp": 430,
	"./zh-CN/discover.webp": 431,
	"./zh-CN/friends.webp": 432,
	"./zh-CN/library.webp": 433,
	"./zh-TW/buddy_read.webp": 434,
	"./zh-TW/discover.webp": 435,
	"./zh-TW/friends.webp": 436,
	"./zh-TW/library.webp": 437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 409;